/* eslint-disable no-empty-pattern */
import { useQuery } from 'react-query'
import { get } from 'framework/api/http'

const getPartnerOrderByWarehouseOrderNo = async (reqData: any) => {
  const data = reqData.queryKey[1]
  if (data.wmsOrderNo !== '') {
    const res = await get(`/PartnerOrders/WarehouseOrder/${data.wmsOrderNo}`)
    return res.data
  } else {
    return null
  }
}

export const useGetPartnerOrderDetailsByWarehouseOrderNo = (
  { ...reqData },
  onSuccess: any,
  onError: any,
) => {
  return useQuery(['userData', reqData], getPartnerOrderByWarehouseOrderNo, {
    refetchOnWindowFocus: false,
    retry: 1,
    enabled: false,
    onSuccess,
    onError,
  })
}

export default useGetPartnerOrderDetailsByWarehouseOrderNo
